import DateUtils from './DateUtils';
import { validateEmail as validateEmailPattern } from './helpers';

export class Form {
	classes = {
		inputError: 'input__error',
		errorMessage: 'input__error-text--active',
	};
	inputsError = [];
	date = new Date();

	constructor(form, sendForm, handlers) {
		this.form = form;
		this.sendForm = sendForm;
		this.handlers = handlers;
		this.selectApartment = form.querySelector('#selectApartment');
		this.startDateInput = form.querySelector('#startDate');
		this.endDateInput = form.querySelector('#endDate');
		this.emailInput = form.querySelector('#mail');
		this.messageInput = form.querySelector('#message');
		this.popup = document.querySelector('#popup');
		this.fnameInput = document.querySelector('#fname');
		this.lnameInput = document.querySelector('#lname');
		this.checkbox = document.querySelector('#politics');
		this.secondNameFake = document.querySelector('#secondName');
		this.fmessageFake = document.querySelector('#fmessage');
		this.inputs = [
			this.selectApartment,
			this.startDateInput,
			this.endDateInput,
			this.emailInput,
			this.messageInput,
			this.fnameInput,
			this.lnameInput,
		];

		this._setDateInputs(this.date, DateUtils.nextYearDate(this.date, 2));
		this._addHandlers();
	}

	async _handleChangeSelectApartment(e) {
		e.target.disabled = true;
		this._resetDateInputs();
		const { changeCalendar } = this.handlers;
		const apartmentId = e.target.value;
		if (apartmentId === 'start') {
			this._setDisabledDateInputs(true);
			return;
		} else this._setDisabledDateInputs(false);

		try {
			const data = await changeCalendar(apartmentId);
			e.target.disabled = false;
			if (data.currentDate) this.date = data.currentDate;
			this._setDateInputs(data.min, data.max);
		} catch (err) {
			e.target.disabled = false;
		}
	}

	async _handleFormSubmit(e) {
		e.preventDefault();
		this.resetErrors();
		const sendForm = this.sendForm;
		const form = this.form;
		try {
			await this._validate();
			await this.sendForm(this.form);
		} catch (err) {
			console.error(err);
		}
	}

	async _validate() {
		this._validateApartment();
		this._validateDates();
		this._validateEmail();
		this._validateEmpty(this.lnameInput);
		this._validateEmpty(this.fnameInput);
		this._validateEmpty(this.messageInput);
		this._validateCheckbox(this.checkbox);
		if (this.inputsError.length > 0) {
			this.inputsError[0].scrollIntoView({ block: 'center' });
			throw new Error('wrong inputs');
		}
		// honeypot
		if (this.secondNameFake.value || this.fmessageFake.value) {
			throw new Error('wrong inputs');
		}
	}

	_validateCheckbox(checkbox) {
		if (!checkbox) return;
		if (!checkbox.checked) {
			this._inputError('brak zaznaczenia', this.checkbox);
		}
	}

	_validateDates() {
		if (!this.startDateInput || !this.endDateInput) return;
		if (!this.startDateInput.value || !this.endDateInput.value)
			this._inputError('Wybierz daty', this.startDateInput, this.endDateInput);

		const startDate = new Date(this.startDateInput.value);
		const endDate = new Date(this.endDateInput.value);
		const today = new Date(this.date).setDate(this.date.getDate() - 1);

		if (startDate < today)
			this._inputError('zła data przyjazdu', this.startDateInput);

		if (startDate > endDate)
			this._inputError(
				'zły zakres dat',
				this.startDateInput,
				this.endDateInput
			);

		if (startDate.getDate() === endDate.getDate())
			this._inputError(
				'za krótki okres',
				this.startDateInput,
				this.endDateInput
			);
	}

	_validateApartment() {
		const apartmentId = this.selectApartment.value;
		if (apartmentId === 'start')
			this._inputError('Wybierz Apartament', this.selectApartment);
	}

	_validateEmail() {
		const email = this.emailInput.value;
		const isValid = validateEmailPattern(email);
		if (!isValid) this._inputError('Niepoprawny email', this.emailInput);
	}

	_validateEmpty(root) {
		if (root.value === '') this._inputError('Nie może być puste', root);
	}

	_inputError(message, ...roots) {
		roots.forEach(root => {
			this.inputsError.push(root);
			const { inputError, errorMessage } = this.classes;
			const errorField = root.parentElement.querySelector('#inputError');
			root.classList.add(inputError);
			if (errorField) {
				errorField.classList.add(errorMessage);
				errorField.innerText = message;
			}
		});
	}

	_resetInputError(root) {
		const { inputError, errorMessage } = this.classes;
		const errorField = root.parentElement.querySelector('#inputError');
		root.classList.remove(inputError);
		if (errorField) {
			errorField.classList.remove(errorMessage);
			errorField.innerText = 'brak błędu';
		}
	}

	resetErrors() {
		this.inputsError.forEach(input => this._resetInputError(input));
		this.inputsError = [];
	}

	resetInputs() {
		this.resetErrors();
		this.inputs.forEach(input => {
			input.value = '';
		});
	}

	_setDisabledDateInputs(state = true) {
		this.startDateInput.disabled = state;
		this.endDateInput.disabled = state;
	}

	_resetDateInputs() {
		this.startDateInput.value = null;
		this.endDateInput.value = null;
	}

	_setDateInputs(min, max) {
		this.startDateInput.min = DateUtils.dateInputPattern(min);
		this.endDateInput.min = DateUtils.dateInputPattern(min);
		this.startDateInput.max = DateUtils.dateInputPattern(max);
		this.endDateInput.max = DateUtils.dateInputPattern(max);
	}

	_addHandlers() {
		this.form.addEventListener('submit', this._handleFormSubmit.bind(this));
		this.selectApartment?.addEventListener(
			'change',
			this._handleChangeSelectApartment.bind(this)
		);
	}

	loading() {
		this.popup.classList.add('popup--visible');
		this.popup.innerHTML = `
		<div class="popup__container">
		<i class="ph ph-circle-notch popup__loading-icon"></i>
		<p>wysyłanie</p>
	</div>
		`;
	}

	confirmSend() {
		this.popup.classList.add('popup--visible');
		this.popup.innerHTML = `
		<div class="popup__container">
		<i class="ph ph-check popup__confirm-icon"></i>
		<p>Wiadomość wysłano pomyślnie</p>
		<button class="popup__confirm-btn" id="popupBtn">OK</button>
	</div>
		`;
		this._listenToClosePopup();
	}

	_listenToClosePopup() {
		const btn = this.popup.querySelector('#popupBtn');
		btn.addEventListener('click', this._hidePopup);
	}

	_hidePopup = () => this.popup.classList.remove('popup--visible');

	alertSendError() {
		this.popup.classList.add('popup--visible');
		this.popup.innerHTML = `
		<div class="popup__container">
		<i class="ph ph-x popup__error-icon"></i>
		<p><span class="popup__error-span">Wysyłanie nie powiodło się.</span> Spróbuj ponownie lub napisz na email</p>
		<button class="popup__error-btn" id="popupBtn">OK</button>
		</div>
		`;
		this._listenToClosePopup();
	}
}
